import { Button, ChoiceChip, Field, Input, Text, Textarea } from '@components/ui';
import { errorBody } from '@lib/api/http';
import { useBuyerPurchaseStatMutation, useBuyerRatingMutation } from '@lib/api/rating';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid';
import type { SxProps, Theme } from '@mui/material/styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import type { BuyerRatingJob } from './buyerRatingR8trTypes';
const pillSx: SxProps<Theme> = {
  ml: 1.25,
  mb: { xs: 1, sm: 0 },
  borderRadius: '15px',
  px: { xs: 2, sm: 3 },
  py: 1.25,
  fontSize: 18,
};


const BuyerRatingR8tr = (): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const buyerRating = useBuyerRatingMutation();
  const purchaseStat = useBuyerPurchaseStatMutation();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const jobData = (location.state as { jobData: BuyerRatingJob }).jobData;
  const TabsArray = [8, 7, 6, 5, 4, 3, 2, 1];
  const TipArray = ['8%', '18%', '28%', 'AMT'];
  const [tabeR8tr, setTabeR8tr] = useState(8);
  const [helpR8tr, setHelepR8tr] = useState<boolean | string>(false);
  const [tabeApp, setTabeApp] = useState(8);
  const [saveMoney, setSaveMoney] = useState<number | string>(0);
  const [tipValue, setTipValue] = useState<string | number | null>(null);
  const [tipTab, setTipTab] = useState('');
  const [buyProduct, setBuyProduct] = useState<boolean | string>(false);
  const [commentOne, setCommentOne] = useState('');
  const [commentTwo, setCommentTwo] = useState('');
  const handler8tingTipTab = (value: string): void => {
    let tip: string | number = 0;
    TipArray.forEach((item) => {
      if (value == item) {
        if (value == '8%' || value == '18%' || value == '28%') {
          const percent = value == '8%' ? 8 : value == '18%' ? 18 : 28;
          const rawCost = jobData?.buyerCost;
          const amount =
            rawCost == null ? Number.NaN : (rawCost / 100) * percent;
          tip = amount.toFixed(2);
        }
        setTipValue(tip);
        setTipTab(item);
      }
    });
  };
  const handler8tingR8trTab = (value: number): void => {
    TabsArray.forEach((item) => {
      if (value == item) {
        setTabeR8tr(item);
      }
    });
  };
  const handler8tingAppTab = (value: number): void => {
    TabsArray.forEach((item) => {
      if (value == item) {
        setTabeApp(item);
      }
    });
  };
  const handlePressNextRes = (message?: string): void => {
    setLoading(false);
    toast.error(message ?? '');
  };
  const handlePressNextSuccessRes = (message?: string): void => {
    setLoading(false);
    toast.success(message ?? '');
    if (tipValue != null && Number(tipValue) > 0) {
      navigate('/tip-payment', { state: { tip: tipValue, jobId: jobData.id } });
    } else {
      navigate('/');
    }
  };
  const handlePressNext = (): void => {
    setLoading(true);
    buyerRating.mutate(
      {
        jobId: jobData.id,
        appRating: tabeApp,
        rating: tabeR8tr,
        betterAsACompanyComment: commentOne,
        improvementComment: commentTwo,
      },
      {
        onError: (error: unknown) =>
          handlePressNextRes(errorBody(error).message),
      }
    );
    purchaseStat.mutate(
      {
        jobId: jobData.id,
        moneyR8trSavedYou: saveMoney as number,
        r8trHelpedYouDecide: helpR8tr as boolean,
        boughtTheProduct: buyProduct as boolean,
      },
      {
        onSuccess: (data: unknown) => {
          const result = data as { message?: string };
          handlePressNextSuccessRes(result.message);
        },
        onError: (error: unknown) =>
          handlePressNextRes(errorBody(error).message),
      }
    );
  };
  return (
    <Box>
      <Box
        sx={{
          mt: 2.5,
          mb: 2.5,
          display: 'flex',
          width: '100%',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            width: { xs: '100%', md: '66%' },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              width: { xs: '100%', md: '60%' },
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              mt: 1,
            }}
          >
            <Text sx={{ fontSize: 18, fontWeight: 700 }}>{t('rating.tipYourR8tr')}</Text>
            <Text tone="primary" sx={{ fontSize: 50, fontWeight: 700 }}>
              ${jobData?.buyerCost}
            </Text>
            <Text sx={{ fontSize: 16 }}>{t('rating.noTipProfit')}</Text>
            <Box
              role="group"
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                p: 0,
                mt: 1,
              }}
            >
              {TipArray.map((item) => (
                <ChoiceChip
                  key={item}
                  selected={tipTab == item}
                  onClick={() => handler8tingTipTab(item)}
                  sx={pillSx}
                >
                  {item}
                </ChoiceChip>
              ))}
              <Box
                sx={{
                  ml: 1.25,
                  width: 80,
                  borderRadius: '15px',
                  border: 1,
                  borderColor: 'divider',
                  px: 1.25,
                  py: 0.5,
                }}
              >
                <Input
                  placeholder="$"
                  value={tipValue ?? ''}
                  onChange={(event) => setTipValue(event.target.value)}
                />
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              mt: 2,
            }}
          >
            <Text
              sx={{ fontSize: 18, fontWeight: 700 }}
            >
              {t('rating.satisfiedWithR8tr')}
            </Text>
            <Box
              role="group"
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                p: 0,
              }}
            >
              {TabsArray.map((item) => (
                <ChoiceChip
                  key={item}
                  selected={tabeR8tr == item}
                  onClick={() => handler8tingR8trTab(item)}
                  sx={pillSx}
                >
                  {item}
                </ChoiceChip>
              ))}
            </Box>
          </Box>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              mt: 2,
            }}
          >
            <Text
              sx={{ fontSize: 18, fontWeight: 700 }}
            >
              {t('rating.useAppAgain')}
            </Text>
            <Box
              role="group"
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                p: 0,
              }}
            >
              {TabsArray.map((item) => (
                <ChoiceChip
                  key={item}
                  selected={tabeApp == item}
                  onClick={() => handler8tingAppTab(item)}
                  sx={pillSx}
                >
                  {item}
                </ChoiceChip>
              ))}
            </Box>
          </Box>
        </Box>
        <Box
          component="hr"
          sx={{ mt: 2.5, width: '100%', borderColor: 'divider' }}
        />
        <Grid
          container
          spacing={2}
          justifyContent="center"
          sx={{ mt: 1, mb: 2, width: '100%' }}
        >
          <Grid item xs={12} md={4}>
            <Field label={t('rating.doBetter')}>
              <Textarea
                placeholder={t('common.messagePlaceholder')}
                value={commentOne}
                minRows={4}
                onChange={(event) => setCommentOne(event.target.value)}
              />
            </Field>
          </Grid>
          <Grid item xs={12} md={4}>
            <Field label={t('rating.suggestions')}>
              <Textarea
                value={commentTwo}
                placeholder={t('common.messagePlaceholder')}
                minRows={4}
                onChange={(event) => setCommentTwo(event.target.value)}
              />
            </Field>
          </Grid>
        </Grid>
        <Box component="hr" sx={{ width: '100%', borderColor: 'divider' }} />
        <Box
          sx={{
            mt: 2.5,
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Text sx={{ fontSize: 18, fontWeight: 700 }}>
            {t('rating.thankYou')}
          </Text>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ mt: 2, width: '100%' }}
          >
            <Grid item xs={12} md={4}>
              <FormGroup>
                <FormControlLabel
                  label={t('rating.didYouBuy')}
                  control={
                    <Checkbox
                      onChange={(event) => {
                        setBuyProduct(event.target.value);
                      }}
                    />
                  }
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormGroup>
                <FormControlLabel
                  label={t('rating.helpedDecide')}
                  control={
                    <Checkbox
                      onChange={(event) => {
                        setHelepR8tr(event.target.value);
                      }}
                    />
                  }
                />
              </FormGroup>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              sx={{ px: 2, mt: 1.5, textAlign: 'center' }}
            >
              <Text sx={{ fontSize: 15 }}>
                {t('rating.moneySaved')}
              </Text>
              <Input
                type="text"
                placeholder="$"
                onChange={(event) => {
                  setSaveMoney(event.target.value);
                }}
                sx={{ mt: 1, width: { xs: '80%', sm: '55%' } }}
              />
            </Grid>
          </Grid>
        </Box>
        <Button
          variant="primary"
          onClick={() => {
            handlePressNext();
          }}
          loading={loading}
          sx={{
            mt: 2.5,
            height: 45,
            width: { xs: '40%', sm: '20%' },
            borderRadius: '0 15px 0 15px',
          }}
        >
          {t('common.next')}
        </Button>
      </Box>
    </Box>
  );
};

export default BuyerRatingR8tr;
